/** Washington, DC – same default used by the CMPS public portal. */
export const DEFAULT_MAP_CENTER = { lat: 38.9072, lng: -77.0369 } as const;
export const DEFAULT_MAP_ZOOM = 12;
export const DEFAULT_MAP_MIN_ZOOM = 8;
export const DEFAULT_MAP_BASEMAP = 'topo-vector';
